import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {createSelector} from "reselect";
import { defaultTheme, operationFunctionalities } from "src/config/app-config";

const LOCAL_STORAGE_KEY = "currentOperation";

interface OperationState {
	currentOperation: any | null;
}

const getStoredOperation = () => {
	const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
	return stored ? JSON.parse(stored) : null;
};

const initialState: OperationState = {
	currentOperation: getStoredOperation(),
};

const operationSlice = createSlice({
	name: "operationLS",
	initialState,
	reducers: {
		setCurrentOperation: (state, action: PayloadAction<any>) => {
			state.currentOperation = action.payload;
			localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(action.payload));
		},
	},
});

export const OperationLSActions = operationSlice.actions;
export default operationSlice.reducer;

const selectOperationState = (state: any) => {
	return state.operationLocalStored;
};

export const selectCurrentOperation = createSelector(
    selectOperationState,
    (operation) => operation.currentOperation
);

export const selectCurrentOperationId = createSelector(
    selectCurrentOperation,
    (operation) => operation && operation.id
);

export const selectCurrentOperationName = createSelector(
    selectCurrentOperation,
    (operation) => operation && operation.name
);



export const selectOperationOrganizerId = createSelector(
    selectCurrentOperation,
    (operation) => operation && operation.organizerId
);


export const selectFunctionalities = createSelector(selectCurrentOperation, (operation) => operation && operation.functionalities);

export const selectIsOperationACI = createSelector(
    selectFunctionalities,
    (functionalities) => functionalities && functionalities.indexOf(operationFunctionalities.ACI) > -1
);

export const selectShowGesKpi = createSelector(
    selectFunctionalities,
    (functionalities) => functionalities && functionalities.indexOf(operationFunctionalities.GES_KPI) > -1
);

export const selectTheme = createSelector(selectCurrentOperation, (operation) => operation && operation.theme);


export const selectPrimaryColor = createSelector(selectTheme, (themeFromPMO) => themeFromPMO?._primary || defaultTheme._primary);
export const selectSecondaryColor = createSelector(selectTheme, (themeFromPMO) => themeFromPMO?._secondary || defaultTheme._secondary);
export const selectDoesOperationUseEnphaseData = createSelector(
	selectCurrentOperation,
	(operation) => operation && operation.useEnphaseData
);